import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "container"]

  connect() {
    this.element.addEventListener("change", (e) => {
      // Re-broadcast hero whenever a category select on a checked-main row changes
      if (e.target.matches("select[name$='[category]']")) {
        const row = e.target.closest("[data-garment-pieces-target='row']")
        const mainCb = row?.querySelector("input[type='checkbox'][name$='[main]']")
        if (mainCb?.checked) this.broadcastHero()
      }
    })
    this.broadcastHero()
  }

  add(event) {
    event.preventDefault()
    const index = Date.now()
    const html = this.templateTarget.innerHTML.replace(/__INDEX__/g, index)
    this.containerTarget.insertAdjacentHTML("beforeend", html)
    // New rows clone the template with the per-character ("Worn by") field
    // hidden; reveal it when complex-staging (scenario) is the active mode.
    const scenarioOn = document.querySelector('input[name="single_generation[source_mode]"]:checked')?.value === "scenario"
    const row = this.containerTarget.lastElementChild
    row?.querySelectorAll("[data-scenario-only]").forEach((el) => { el.hidden = !scenarioOn })
  }

  remove(event) {
    event.preventDefault()
    const row = event.currentTarget.closest("[data-garment-pieces-target='row']")
    if (!row) return

    const destroyInput = row.querySelector("input[name*='[_destroy]']")
    const wasMain = row.querySelector("input[type='checkbox'][name$='[main]']")?.checked
    if (destroyInput) {
      destroyInput.value = "1"
      row.style.display = "none"
    } else {
      row.remove()
    }
    if (wasMain) this.broadcastHero()
  }

  mainChanged(event) {
    if (event.target.checked) {
      const checkboxes = this.element.querySelectorAll("input[type='checkbox'][name$='[main]']")
      checkboxes.forEach((cb) => {
        if (cb !== event.target) cb.checked = false
      })
    }
    this.broadcastHero()
  }

  broadcastHero() {
    const checked = this.element.querySelector("input[type='checkbox'][name$='[main]']:checked")
    let payload = { category: null, label: null }

    if (checked) {
      const row = checked.closest("[data-garment-pieces-target='row']")
      const category = row?.querySelector("select[name$='[category]']")?.value || null
      const labelInput = row?.querySelector("input[name$='[label]']")?.value || null
      payload = { category, label: labelInput }
    }

    window.dispatchEvent(new CustomEvent("hero-changed", { detail: payload }))
  }
}
